import { useFeatureFlags } from 'utils/features';

export default function useLegacyReportsEnabled() {
  const enabled = useFeatureFlags('LEGACY_REPORTS_ACCESSIBLE');
  return enabled;
}
